import React from "react";
import { ButtonBase } from "../../../common/components/form";

export default function Confirm(props) {
    const CNPanelConfirm = ["panel-confirm"];
    props.show && CNPanelConfirm.push("show");

    return (
        <div className={CNPanelConfirm.join(" ")}>
            <div className="panel-confirm-content">
                {props.header && <h2 className="panel-confirm-header">{props.header}</h2>}
                {props.text && <p className="panel-confirm-text">{props.text}</p>}

                <div className="panel-confirm-actions">
                    {props?.actions?.map(({ onClick, text, props }, index) => (
                        <ButtonBase key={index} onClick={onClick} {...props}>
                            {text}
                        </ButtonBase>
                    ))}
                </div>
            </div>
        </div>
    );
}
